/**
 * This code is being borrowed from the excellent Material-ui library.
 * We want to use the `createMuiTheme` function without any of the core library overhead.
 * Original code can be found here: https://github.com/mui-org/material-ui/blob/master/packages/material-ui-utils/src/deepmerge.js
 */
export function isPlainObject(item) {
    return item && typeof item === 'object' && item.constructor === Object;
}
export function deepmerge(target, source, options = { clone: true }) {
    const output = options.clone ? { ...target } : target;
    if (isPlainObject(target) && isPlainObject(source)) {
        Object.keys(source).forEach(key => {
            // Avoid prototype pollution
            if (key === '__proto__') {
                return;
            }
            if (isPlainObject(source[key]) && key in target) {
                output[key] = deepmerge(target[key], source[key], options);
            }
            else {
                output[key] = source[key];
            }
        });
    }
    return output;
}
//# sourceMappingURL=deepmerge.js.map